export default class RouterService {
    // typescript compiles this to `#router` to make it private even in JS,
    // but in TS it needs to be called without the visibility specifier
    router;
    constructor(router) {
        this.router = router;
    }
    get name() {
        return this.router.currentRoute.name;
    }
    get query() {
        return this.router.currentRoute.query || {};
    }
    get params() {
        return this.router.currentRoute.params || {};
    }
    /**
     * This is a protected getter only for internal use
     * @private
     */
    get _router() {
        return this.router;
    }
    /**
     * Trigger a route change on the files app
     *
     * @param path the url path, eg: '/trashbin?dir=/Deleted'
     * @param replace replace the current history
     * @see https://router.vuejs.org/guide/essentials/navigation.html#navigate-to-a-different-location
     */
    goTo(path, replace = false) {
        return this.router.push({
            path,
            replace,
        });
    }
    /**
     * Trigger a route change on the files App
     *
     * @param name the route name
     * @param params the route parameters
     * @param query the url query parameters
     * @param replace replace the current history
     * @see https://router.vuejs.org/guide/essentials/navigation.html#navigate-to-a-different-location
     */
    goToRoute(name, params, query, replace) {
        return this.router.push({
            name,
            query,
            params,
            replace,
        });
    }
}
